import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { AuthService } from './services/auth.service';
import { loginComRetorno } from './auth.guard';

export const permissaoGuard: CanMatchFn = (route: Route, _segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const chaves = normalizarChaves(route.data?.['permissao']);
  // `perfis` restringe por perfil, como no menu: o cliente_admin carrega o
  // catálogo inteiro de chaves, então a permissão sozinha não o barraria.
  const perfis = normalizarChaves(route.data?.['perfis']);

  if (chaves.length === 0 && perfis.length === 0) return true;

  return sessaoCarregada(auth).pipe(
    map((logado) => {
      if (!logado) return loginComRetorno(router);

      const negado = router.createUrlTree(['/sem-acesso']);

      if (perfis.length > 0) {
        const perfil = auth.usuario?.perfil;
        if (!perfil || !perfis.includes(perfil)) return negado;
      }

      return auth.temPermissao(...chaves) || negado;
    }),
  );
};

function sessaoCarregada(auth: AuthService): Observable<boolean> {
  return auth.usuario ? of(true) : auth.verificarSessao();
}

function normalizarChaves(valor: unknown): string[] {
  if (typeof valor === 'string') return [valor];
  if (Array.isArray(valor)) return valor.filter((chave): chave is string => typeof chave === 'string');

  return [];
}
